import { ComputedRef, InjectionKey } from "vue";

export default Symbol() as InjectionKey<ComputedRef<string> | null>;
